import React from 'react';
import { Paper, makeStyles, Theme } from '@material-ui/core';
import clsx from 'clsx';
import { NumericMetricInfo } from '@moderepo/mode-apis';


const useStyle = makeStyles((theme: Theme) => {
    return {
        root: {
            height                      : '100%',
            padding                     : theme.spacing(1),
            display                     : 'flex',
            flexDirection               : 'column',
            alignItems                  : 'center',
            justifyContent              : 'center',
            [theme.breakpoints.up('md')]: {
                padding: theme.spacing(1.5),
            },
        },

        metricValue: {
            flex          : 1,
            height        : '100%',
            width         : '100%',
            color         : theme.palette.text.primary,
            fontSize      : 20,
            display       : 'flex',
            flexDirection : 'row',
            alignItems    : 'center',
            justifyContent: 'center',
            paddingBottom : theme.spacing(2),

            '& .value': {
                fontWeight: 500,
            },

            '& .unit': {
                color     : theme.palette.text.secondary,
                fontWeight: 'normal',
            },

            [theme.breakpoints.up('md')]: {
                fontSize: 24,
            },
        },

        metricValueName: {
            color                       : theme.palette.text.secondary,
            fontWeight                  : 500,
            fontSize                    : 16,
            textAlign                   : 'center',
            [theme.breakpoints.up('md')]: {
                fontSize: 18,
            },
        },

        metricValueUnit: {
            paddingLeft: 5,
        },
    };
});



export interface DefaultNumericMetricValueDisplayProps {
    readonly className?: string;
    readonly numericMetric: NumericMetricInfo;
    readonly valueName: string;
    readonly value?: number;
    readonly displayValue: string;
}


/**
 * This is a Generic component used for displaying numericMetric value. This component can be used for displaying any numericMetric value however,
 * all it does is display the value as numbers. This component does not have any special UI.
 * @param props
 */
export const DefaultNumericMetricValueDisplay = (props: DefaultNumericMetricValueDisplayProps) => {
    const classes = useStyle();

    return (
        <Paper className={clsx(classes.root, props.className)}>
            <div className={classes.metricValue}>
                <div className="value">
                    {props.displayValue}
                </div>
                {props.numericMetric && props.numericMetric.unit && (
                    <div className="unit">{props.numericMetric.unit}</div>
                )}
            </div>
            <div className={classes.metricValueName}>
                {props.numericMetric ? props.numericMetric.displayName || props.numericMetric.name : props.valueName}
                {props.numericMetric && props.numericMetric.unit && (
                    <span className={classes.metricValueUnit}>[{props.numericMetric.unit}]</span>
                )}
            </div>
        </Paper>
    );
};
